import { render } from "./ShopItem.vue?vue&type=template&id=8a8b900a&scoped=true"
import script from "./ShopItem.vue?vue&type=script&lang=js"
export * from "./ShopItem.vue?vue&type=script&lang=js"

import "./ShopItem.vue?vue&type=style&index=0&id=8a8b900a&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8b900a"]])

export default __exports__